import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ParentSize } from "@visx/responsive";
import { ApplicationState } from '../reducers/Index';
import { withUserActionTracker } from '../sharedUtilities/UserActionTracker';

//import "./Benchmarking.css";

interface BenchmarkingState {
    currentDateTime?: any;
}

class Benchmarking extends React.Component<RouteComponentProps<{}>, BenchmarkingState> {
    constructor(props) {
        super(props);

        let now: Date = new Date();
        var currentDate = now.getFullYear() + "_" + (now.getMonth() + 1) + "_" + now.getDate();

        this.state = {
            currentDateTime: currentDate,
        };
    }


    reportHeight = 0;

    

    componentDidUpdate(prevProps) {
       
    }
    
    public render() {

        const { path } = this.props.match;
         return (
             <div>
                 yo
             </div>
        );
    }
}

//export const ReportContainer = styled.div`
//    max-width: max(90%, 1080px);
//    margin-inline: auto;
//`;

//export const ReportContent = styled.article`
//    padding: 15px;
//    border-radius: 5px;
//    background: white;
//`;



function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            //loadEarlyCareerReport: loadEarlyCareerReport,
            //loadEarlyCareerSharedReport: loadEarlyCareerSharedReport
        }, dispatch
    );
}


const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    EarlyCareerReportState: state.earlyCareerReportProperties
});

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(withUserActionTracker(Benchmarking, "Benchmarking Landing Page", "landing page"));

